module.exports = __webpack_public_path__ + "4bc3c43f3108d219611a4bca9ceacfa3.svg";